import React from "react";

export function SectionHeading({ overline, title, subtitle, align = "left", light = false, className = "" }) {
  return (
    <div
      className={`${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} ${className}`}
      data-testid="section-heading"
    >
      {overline && (
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-teal mb-3">{overline}</p>
      )}
      <h2
        className={`font-heading text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight font-semibold ${
          light ? "text-white" : "text-ink"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
